import { useEffect, useState } from "react";
import TierAccountService from "../../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import DataTableAccountImpayes from "../../Impayes/DataTableAccountTransactions";
import withLoader from "../../../../components/layouts/WithLoader";


const DetailsPayementsFournisseur = ({ startLoading, stopLoading }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [listTransaction, setListTransaction] = useState([]);
  const [none, setNone] = useState();

  // const [tierAccount, setTierAccount] = useState();

  useEffect(() => {
    startLoading();
    TierAccountService.getEcheancesFicheFournisseurByTiers(
      getCurrentUserId(),
      localStorage.getItem("idTiers")
    )
      .then((response) => {
        if (response.data.success) {
          setListTransaction(response.data.list);
          setNone(response.data.none);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
       <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                Les échéances du fournisseur{" "}
                <b>{localStorage.getItem("nameTiers")}</b>
              </h5>

              <br />
              <br />
              <div className="row">
                <div className="col-sm-6">
                  {" "}
                  {none && (
                    <>
                      <b>ECHEANCE : </b> {none}{" "}
                    </>
                  )}
                </div>
            
            
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3"></div>

              {listTransaction.length !== 0 && (
                <DataTableAccountImpayes listTransaction={listTransaction} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(DetailsPayementsFournisseur);
